import React, { useReducer, useState } from "react";
import "./StepsComponent.scss";
import { AllImages } from "../../Assets/Images/AllImages";
import user from "../../Common/JsonFiles/simran.json";

const StepsComponent = () => {
  const [selectedTab, setSelectedTab] = useState("education");

  const handleFirstTabClick = () => {
    setSelectedTab("education");
  };
  const handleSecondTabClick = () => {
    setSelectedTab("work");
  };

  return (
    <div className="steps-main-container">
      <div className="steps-tabs">
        <div
          className={`education-text-img d-flex ${
            selectedTab === "education" ? "active-tab" : ""
          }`}
          onClick={() => handleFirstTabClick()}
        >
          {/* <img width={25} src={AllImages.GraduationCapIcon} alt="" /> */}
          <div className="graduation-cap-icon"></div>
          <span className={`text-color`}>Eductation</span>
        </div>
        <div
          className={`work-text-img d-flex  ${
            selectedTab === "work" ? "active-tab" : ""
          }`}
          onClick={() => handleSecondTabClick()}
        >
          {/* <img width={25} src={AllImages.GraduationCapIcon} alt="" /> */}
          <div className="work-icon"></div>
          <span className={`text-color`}>Work</span>
        </div>
      </div>

      {selectedTab === "education" && (
        <div className="steps-timeline">
          {user?.education.map((item ,id) => {
            return (
              <div className="steps-content"  key={id.toString()}>
                <div className="step-name">{item.course}</div>
                <div className="step-sub-name">{item.collegeName}</div>
                <div className="step-sub-name">{item.university}</div>
                <div className="d-flex">
                  <div className="calendar-icon"></div>
                  <span className="step-date">
                    {item.startDate} 
                  </span>
                  <span className="step-hyphen">{" - "}</span>
                  <span className="step-date">{item.endDate}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {selectedTab === "work" && (
        <div className="steps-timeline">
          {user?.experience.map((item,id) => {
            return (
              <div className="steps-content"  key={id.toString()}>
                <div className="step-name">{item.jobTitle}</div>
                <div className="step-sub-name">{item.company}</div>
                <div className="d-flex">
                  <div className="calendar-icon"></div>
                  <span className="step-date">
                    {item.startDate} {" - "}
                  </span>
                  <span className="step-date">{item.endDate}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StepsComponent;

{
  /* <img
              className="step-icon"
              width={20}
              src={AllImages.CheckedCircleIcon}
              alt=""
            /> */
}
